import type { ImagingRow, LabRow, MedicationRow, ResultRow } from "./types";

export const LAB_FIELDS = [
  ["date", "Date"],
  ["calcium", "Ca"],
  ["ionized_calcium", "Ionized"],
  ["pth", "PTH"],
  ["gfr", "GFR"],
  ["creatinine", "Creat"],
  ["vitamin_d", "Vit D"],
  ["albumin", "Albumin"],
] as const;

export type LabField = (typeof LAB_FIELDS)[number][0];
export type HiddenLabField = "reference_range" | "pth_reference_range";
export type HiddenLabUnitField =
  | "calcium_unit"
  | "ionized_calcium_unit"
  | "pth_unit"
  | "creatinine_unit"
  | "vitamin_d_unit"
  | "albumin_unit";

export const LAB_HIDDEN_FIELDS: HiddenLabField[] = ["reference_range", "pth_reference_range"];
export const LAB_HIDDEN_UNIT_FIELDS: HiddenLabUnitField[] = [
  "calcium_unit",
  "ionized_calcium_unit",
  "pth_unit",
  "creatinine_unit",
  "vitamin_d_unit",
  "albumin_unit",
];
export const LAB_FIELD_UNITS: Partial<Record<LabField, string>> = {
  calcium: "mg/dL",
  ionized_calcium: "mg/dL",
  pth: "pg/mL",
  creatinine: "mg/dL",
  vitamin_d: "ng/mL",
  albumin: "g/dL",
};

export const EMPTY_MEDICATION: MedicationRow = { name: "", dose: "", frequency: "", source: {} };

export const EMPTY_LAB: LabRow = {
  date: "",
  calcium: "",
  ionized_calcium: "",
  calcium_unit: "",
  ionized_calcium_unit: "",
  reference_range: "",
  pth: "",
  pth_unit: "",
  pth_reference_range: "",
  gfr: "",
  creatinine: "",
  creatinine_unit: "",
  vitamin_d: "",
  vitamin_d_unit: "",
  albumin: "",
  albumin_unit: "",
  source: {},
};

export const EMPTY_RESULT: ResultRow = { date: "", value: "", unit: "", reference_range: "", source: {} };
export const EMPTY_IMAGING: ImagingRow = { date: "", image_type: "", results: "", source: {} };
